import IMG_LOGO from 'images/default/logo.svg';
import IMG_KNOLSKAPE_LOGO from 'images/default/logo_knolskape.png';
import IMG_AGILE from 'images/default/agile.png'
import IMG_INTRO_CASE_OBJECTIVE from 'images/default/intro/caseObj.png'
import INTRO_SIDE_1 from 'images/default/intro/side1.png';
import INTRO_SIDE_2 from 'images/default/intro/side2.png';

import IMG_CEO from 'images/default/intro/ceo.png';
import IMG_COMPANY from 'images/default/intro/company.png';
import IMG_TEAM from 'images/default/intro/team.png';
import IMG_DEFAULT_PRD from 'images/default/prds/default_prd.png';
import IMAGE_PRD_1 from 'images/default/prds/image_prd_1.png';
import IMAGE_PRD_2 from 'images/default/prds/image_prd_2.png';
import IMAGE_PRD_3 from 'images/default/prds/image_prd_3.png';
import IMG_DEFAULT_FEATURE from 'images/default/features/default_feature.png';
import SIM_BACKGROUND from 'images/default/sim_background.jpg';


import IMG_SETTING_PRIORITY from 'images/default/others/setting_priority.png';
import IMG_TASKS_COMPLETED from 'images/default/others/tasks_completed.png';
import IMG_MVP_ACHIEVED from 'images/default/others/mvp_achieved.png';
import IMG_TIME_RAN_OUT from 'images/default/others/time_ran_out.png';
import IMG_DAYS_RAN_OUT from 'images/default/others/days_ran_out.png';
import IMG_ROTATE from 'images/default/rotate.png';

//actions
// import default_action from 'images/default/actions/default_action.png';
// import team_lunch from 'images/default/actions/team_lunch.png';
// import standup from 'images/default/actions/standup.png';
// import market_pulse_survey from 'images/default/actions/market_pulse_survey.png';
// import rebuild_feature from 'images/default/actions/rebuild_feature.png';
// import replan_sprint from 'images/default/actions/replan_sprint.png';
// import retrospect from 'images/default/actions/retrospect.png';
// import team_motivation_survey from 'images/default/actions/team_motivation_survey.png';
// import update_prd from 'images/default/actions/update_prd.png';
// import user_feedback from 'images/default/actions/user_feedback.png';

//action responses
import default_response from 'images/default/actions/actionResponses/default_response.png';
import align_team_response from 'images/default/actions/actionResponses/align_team_response.png';
import feedback_interview_response from 'images/default/actions/actionResponses/feedback_interview_response.png';
import feedback_survey_response from 'images/default/actions/actionResponses/feedback_survey_response.png';
import market_pulse_survey_response from 'images/default/actions/actionResponses/market_pulse_survey_response.png';
import meet_team_response from 'images/default/actions/actionResponses/meet_team_response.png';
import replace_sprint_response from 'images/default/actions/actionResponses/replace_sprint_response.png';
import retrospect_response from 'images/default/actions/actionResponses/retrospect_response.png';
import team_huddle_response from 'images/default/actions/actionResponses/team_huddle_response.png';
import team_lunch_response from 'images/default/actions/actionResponses/team_lunch_response.png';
import team_morale_survey_response from 'images/default/actions/actionResponses/team_morale_survey_response.png';
import train_team_response from 'images/default/actions/actionResponses/train_team_response.png';
import update_prd_response from 'images/default/actions/actionResponses/update_prd_response.png';

//event responses
import negative_event_response from 'images/default/events/negative_event_response.png';
import positive_event_response from 'images/default/events/positive_event_response.png';
import neutral_event_response from 'images/default/events/neutral_event_response.png';
import IMG_LEADERBOARD_BACKGROUND from 'images/default/leaderboard_background.png';

const images = {
	IMG_LOGO,
	IMG_KNOLSKAPE_LOGO,
	IMG_AGILE,
	IMG_INTRO_CASE_OBJECTIVE,
	IMG_CEO,
	IMG_COMPANY,
	IMG_TEAM,
	IMG_DEFAULT_PRD,
	IMAGE_PRD_1,
	IMAGE_PRD_2,
	IMAGE_PRD_3,
	IMG_DEFAULT_FEATURE,
	SIM_BACKGROUND,
	INTRO_SIDE_1,
	INTRO_SIDE_2,

	// default_action,
	// team_lunch,
	// standup,
	// market_pulse_survey,
	// rebuild_feature,
	// replan_sprint,
	// retrospect,
	// team_motivation_survey,
	// update_prd,
	// user_feedback,

	default_response,
	align_team_response,
	feedback_interview_response,
	feedback_survey_response,
	market_pulse_survey_response,
	meet_team_response,
	replace_sprint_response,
	retrospect_response,
	team_huddle_response,
	team_lunch_response,
	team_morale_survey_response,
	train_team_response,
	update_prd_response,

	positive_event_response,
	negative_event_response,
	neutral_event_response,

	IMG_SETTING_PRIORITY,
	IMG_TASKS_COMPLETED,
	IMG_MVP_ACHIEVED,
	IMG_TIME_RAN_OUT,
	IMG_DAYS_RAN_OUT,
	IMG_ROTATE,
	IMG_LEADERBOARD_BACKGROUND
};

export default images;
